import { render, staticRenderFns } from "./feedback_system.vue?vue&type=template&id=06ad05e8&"
import script from "./feedback_system.vue?vue&type=script&lang=js&"
export * from "./feedback_system.vue?vue&type=script&lang=js&"
import style0 from "./feedback_system.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports